<template>
	<PopupRouterView :showLeftIcon="true" label="Download Process Input"  entityName="downloadprocess" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-job-id" label-cols-sm="4" label-cols-lg="3" label="" label-for="input-job-id" size="sm" :model.sync="model.jobId"   />
				<app-input-textbox id="fieldset-function-id" label-cols-sm="4" label-cols-lg="3" label="Function Id" label-for="input-function-id" size="sm" :model.sync="model.functionId"   />
				<app-input-textbox id="fieldset-file-name" label-cols-sm="4" label-cols-lg="3" label="" label-for="input-file-name" size="sm" :model.sync="model.fileName"   />
				<app-input-datetimepicker  id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" label="Start Time" size="sm" :model.sync="model.startTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
				<app-input-datetimepicker  id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" label="End Time" size="sm" :model.sync="model.endTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
				<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="input-status" size="sm" :model.sync="model.status"   />
				<app-input-textarea id="fieldset-error-message" label-cols-sm="4" label-cols-lg="3" label="Error Message" label-for="input-error-message" size="sm" :model.sync="model.errorMessage"   />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';
import DownloadProcessList from '@/models/DownloadProcess/DownloadProcessList';
import DownloadProcessFilter from '@/filters/DownloadProcess/DownloadProcessFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputDatetimepicker,AppInputDatetimepickerRange,AppInputTextarea,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDownloadProcess : null,
			currentDownloadProcessPage : 1,
			downloadProcessPageSize: 10,
			sortByDownloadProcess: '',
			sortDescDownloadProcess: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDownloadProcess : async function(id) {
			this.isBusy = true;
			DownloadProcess.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDownloadProcess = true;
			this.filterDownloadProcess.id = this.modelId;
			DownloadProcess.downloadDataDetail(this, this.filterDownloadProcess).then(result => {
				this.isDownloadDownloadProcess = false;
			}).catch(error => { this.isDownloadDownloadProcess = false; })
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				DownloadProcess.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'downloadprocessindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				DownloadProcess.insertData(this, model).then(result => {
					this.$router.push({ name: 'downloadprocessindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getDownloadProcesss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDownloadProcess = new DownloadProcessFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDownloadProcess(id);
			} else {
				this.modelId = id;
				this.getDownloadProcess(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
